import React, { useState, useEffect } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import AssetQrCodeReportFormSearch from './AssetQrCodeReportFormSearch'
import AssetQrCodeReportTable from './AssetQrCodeReportTable'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { cloneDeep } from 'lodash'
import {
  searchAssetQrCodeReportPage,
  PostDownloadAssetQrCodeReportPage,
} from '../../../redux/actions/addDurableArticles'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import { downloadFile } from '../../../utils/fileUtil'

export default function AssetQrCodeReportWidget(props) {
  const { projectCode } = props

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchAssetQrCodeReportPage(projectCode, request, pagenumber, pagesize)
      // console.log('response ', response)
      if (response) {
        let _schema = cloneDeep(formSchema)

        _schema.result = response.model
        setFormSchema(_schema)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const file = await PostDownloadAssetQrCodeReportPage(projectCode, request)

      if (file) {
        downloadFile(file, file.name || `ข้อมูลรายการ_QR_Code_ครุภัณฑ์`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnExport = () => {
    const request = {
      assetCode: searchRequest.assetCode,
      assetName: searchRequest.assetName,
      assetType: searchRequest.assetType,
      approvedStartDate: searchRequest.approvedStartDate,
      approvedEndDate: searchRequest.approvedEndDate,
    }
    // console.log('aaaa', request)

    handleExportFile(request)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema?.header || ' '} bordered>
        <MiniProjectInfo schema={formSchema?.projectInfo} />
        <br />

        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <AssetQrCodeReportFormSearch
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="print" className="bt-gost-icon-radius" />}
              onClick={() => {
                handleOnExport({})
                // console.log('xxxx')
              }}
            >
              พิมพ์
            </IconButton>
          </Col>
        </Row>

        <AssetQrCodeReportTable
          schema={formSchema?.result}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
          // onExport={handleExportFile}
        />
        {/* <ProjectClosingRequestTable schema={formSchema?.form?.formTable} /> */}
      </Panel>
    </>
  )
}
